// ============================================================
// adidas STRENGTH — THEME JS
// ============================================================
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  // Header condensé au scroll
  var hd = document.querySelector('.hd');
  if (hd) {
    window.addEventListener('scroll', function () {
      hd.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // Menu mobile : overlay plein écran (délégation = robuste)
  function setMenu(state) {
    var m = document.querySelector('.mnav');
    if (!m) return;
    m.classList.toggle('open', state);
    m.setAttribute('aria-hidden', state ? 'false' : 'true');
    document.body.classList.toggle('menu-open', state);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.bg')) { e.preventDefault(); setMenu(true); return; }
    if (e.target.closest('.mnav-close')) { setMenu(false); return; }
    if (e.target.closest('.mnav a')) { setMenu(false); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  // Apparition au scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  // Dots des carrousels (catégories, à la une, collection)
  function setupCarousel(track) {
    if (!track || track.dataset.carInit) return;
    track.dataset.carInit = '1';
    var dots = document.createElement('div');
    dots.className = 'dots';
    track.parentNode.insertBefore(dots, track.nextSibling);
    function itemWidth() {
      var items = track.children;
      if (!items.length) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }
    function setActive() {
      var iw = itemWidth(); if (!iw) return;
      var idx = Math.round(track.scrollLeft / iw);
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('active', i === idx); });
    }
    function render() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      if (!scrollable) { dots.style.display = 'none'; return; }
      dots.style.display = 'flex';
      var count = track.children.length;
      if (dots.children.length !== count) {
        dots.innerHTML = '';
        for (var i = 0; i < count; i++) {
          (function (idx) {
            var b = document.createElement('button');
            b.className = 'dot';
            b.setAttribute('aria-label', 'Slide ' + (idx + 1));
            b.addEventListener('click', function () { track.scrollTo({ left: idx * itemWidth(), behavior: 'smooth' }); });
            dots.appendChild(b);
          })(i);
        }
      }
      setActive();
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
    window.addEventListener('resize', render);
    render();
  }
  ['.cat-grid', '.feat', '.car-m'].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(setupCarousel);
  });

  // Filtres repliés par défaut sur mobile
  if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
    document.querySelectorAll('.col-side details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  // Galerie produit : vignette -> grande image
  var main = document.getElementById('pdMain');
  if (main) {
    document.querySelectorAll('.pd-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.pd-thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
      });
    });
  }

  // Quantité
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-minus]');
    var plus = wrap.querySelector('[data-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1; if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1; input.value = v + 1;
    });
  });

  // Sélecteur de variantes
  var form = document.querySelector('.pd-form');
  if (form && window.__product) {
    var product = window.__product;
    var idInput = form.querySelector('[name="id"]');
    var priceNow = document.querySelector('[data-price-now]');
    var addBtn = form.querySelector('[data-add-btn]');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-opt]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0 }) + ' €';
    }
    function update() {
      var v = findVariant(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Ajouter au panier — ' + money(v.price); }
        else { addBtn.disabled = true; addBtn.textContent = 'Indisponible'; }
      }
    }
    form.querySelectorAll('[data-opt] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var label = inp.closest('.size');
        if (label) {
          inp.closest('[data-opt]').querySelectorAll('.size').forEach(function (s) { s.classList.remove('on'); });
          label.classList.add('on');
        }
        update();
      });
    });
    update();
  }
});
